import type {ListClientsSearch} from "./-types";

import {listClientsQueryOptions} from "@project/application/sales/clients";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";

import {ClientsPage} from "./-page/clients.page";
import {ClientsPending} from "./-page/clients.pending";
import {listClientsSearchSchema} from "./-types";

export type {ListClientsSearch} from "./-types";

export const Route = createFileRoute("/_app/sales/clients/")({
  component: ClientsPage,
  errorComponent: AppErrorBoundary,
  loader: async ({context: {queryClient}, deps, cause}) => {
    if (cause === "enter") {
      return queryClient.ensureQueryData(listClientsQueryOptions(deps as ListClientsSearch));
    }

    void queryClient.prefetchQuery(listClientsQueryOptions(deps as ListClientsSearch));

    return;
  },
  loaderDeps: ({search}) => search,
  pendingComponent: ClientsPending,
  staticData: {meta: {breadcrumbs: {hide: true}}},
  validateSearch: (search) => listClientsSearchSchema.parse(search),
});
